












































































/* eslint-disable @typescript-eslint/no-explicit-any */
import G_020_JuchuEntry_ChildActionsBtn from '@/components/G_kaigai/G_020_JuchuEntry_ChildActionsBtn.vue';
import { Flg, SumiFlg, JotaiKb } from '@/constants/constants';
import { getDefaultPagerInfo } from '@/utils/utils';
import Vue from 'vue';

export default Vue.extend<any, any, any, any>({
  name: 'G_020_JuchuEntry_Table',
  components: {
    G_020_JuchuEntry_ChildActionsBtn,
  },
  props: {
    search: {
      type: String,
      default: '',
    },
    items: {
      type: Array,
      default: () => [],
    },
  },
  data: () => ({
    Flg,
    SumiFlg,
    JotaiKb,
    headers: [
      {
        text: '発注日',
        value: 'hatchuYmd',
        width: 100,
        sortable: true,
      },
      {
        text: '発注№',
        value: 'tokuisakiHatchuNo',
        width: 90,
        class: 'text-end',
        cellClass: 'text-end',
        sortable: true,
      },
      {
        class: 'text-start',
        cellClass: 'text-start',
        text: '状態',
        value: 'jotaiKb',
        width: 60,
        sortable: false,
      },
      {
        text: '得意先',
        value: 'tokuisakiMei',
        class: 'text-truncate',
        cellClass: 'text-truncate',
        width: 340,
        sortable: true,
      },
      {
        text: '納品先',
        value: 'nohinsakiMei',
        width: 408,
        sortable: true,
      },
      {
        text: '品目（1件目）',
        value: 'himmokuMei',
        class: 'text-truncate',
        cellClass: 'text-truncate',
        width: 450,
        sortable: true,
      },
      {
        text: '重量計',
        value: 'juryoKei',
        width: 120,
        sortable: true,
        class: 'text-end',
        cellClass: 'text-end',
      },
      {
        text: '納品希望日',
        value: 'nohinkiboYmd',
        width: 120,
        sortable: true,
      },
      {
        text: '自社伝票№',
        value: 'jishaDenpyoNo',
        width: 200,
        sortable: true,
      },
      {
        class: 'text-start',
        cellClass: 'text-start',
        text: '状態名',
        value: 'jotaiKbMei',
        sortable: true,
        width: 140,
      },
      { text: '', value: 'action', sortable: false, width: 40 },
    ],
    footerProps: {},
    options: {
      page: 1,
      itemsPerPage: 10,
      sortBy: [],
      sortDesc: [],
    },
  }),
  computed: {
    tableHeight() {
      return this.$vuetify.breakpoint.height - 330;
    },
  },
  methods: {
    customSearch(_value: any, search: string | null, item: any) {
      const filterValues = [
        item['hatchuYmd'],
        item['tokuisakiHatchuNo'],
        item['tokuisakiMei'],
        item['nohinsakiMei'],
        item['himmokuMei'],
        item['juryoKei'],
        item['nohinkiboYmd'],
        item['jishaDenpyoNo'],
        item['jotaiKbMei'],
      ];

      return filterValues.some(
        (v: any) =>
          v &&
          v
            .toString()
            .toLowerCase()
            .includes(search ? search.toLowerCase() : '')
      );
    },
  },
  mounted() {
    const pagerInfo = getDefaultPagerInfo();
    this.footerProps = pagerInfo.footerProps;
    this.options.itemsPerPage = pagerInfo.itemPerPage;
  },
});
